import { render } from "./InputSituation.vue?vue&type=template&id=3b5cae79"
import script from "./InputSituation.vue?vue&type=script&lang=js"
export * from "./InputSituation.vue?vue&type=script&lang=js"

import "./InputSituation.vue?vue&type=style&index=0&id=3b5cae79&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__